module.exports = __webpack_public_path__ + "static/media/parkhub-logo-white.e5dea483.svg";